export default "__VITE_PUBLIC_ASSET__3337141c__"